// extracted by mini-css-extract-plugin
export default {"pageTitle":"wastePercentage__pageTitle___WpiP5","tabs":"wastePercentage__tabs___AEG5I"};